import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

import reducers from '../redux/reducers';
import rootSaga from '../redux/sagas';

const sagaMiddleware = createSagaMiddleware();
const history = createBrowserHistory();

const {
  routerMiddleware,
  routerReducer,
  createReduxHistory,
} = createReduxHistoryContext({
  history,
  reduxTravelling: true,
  savePreviousLocations: 1,
});

const middlewares = [thunk, sagaMiddleware, routerMiddleware];
const enhancers = [];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer, // important
  }),
  compose(applyMiddleware(...middlewares), ...enhancers)
);

sagaMiddleware.run(rootSaga);

const reduxHistory = createReduxHistory(store);

export { store, reduxHistory as history };
